import React from 'react';

import * as S from './styles';

const Header: React.FC = () => {
  return (
    <S.Container>
      <S.Title>
        A nova geração
        <br />
        deixa sua marca
      </S.Title>
      <S.Description>
        Sete labels de jovens estilistas reescrevem como se faz e consome moda
        no país.
      </S.Description>
      <S.Credits>
        Por <span>Rener Oliveira</span>
      </S.Credits>
    </S.Container>
  );
};

export default Header;
